<template>
  <div class="top-wrapper">
    <div class="top-container" style="height: 80vh">
      <div v-show="true" class="view full-bg-img" :style="{ backgroundImage: 'url(' + require('@/assets/images/header_bg.jpg') + ')' }">
        <div>
          <mdb-mask overlay="black-light" class="flex-center">
            <mdb-container>
              <div class="white-text text-center mt-4">
                <h4 class="h4">{{ $t('top.catchphrase') }}</h4>
                <img src="@/assets/images/waaarp_logo_wh.png" class="top-logo"/>
                <section class="form-dark">
                  <mdb-row>
                    <mdb-col col="12" md="8" offsetMd="2">
                      <div class="input-group room-input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text text-white font-italic">{{ appURL }}</span>
                        </div>
                        <input v-model="roomName" type="text" :class="['form-control', { 'is-invalid': validation.roomName.invalid || validation.roomName.IncludedBlacklist }]"/>
                      </div>
                      <div v-if="validation.roomName.invalid" class="room-name-invalid-feedback">
                        半角英数字、_(アンダーバー)、-(ハイフン)のみを使用し12文字以上で部屋名を設定してください
                      </div>
                      <div v-else-if="validation.roomName.IncludedBlacklist" class="room-name-invalid-feedback">
                        入力された部屋名は使用できません
                      </div>
                    </mdb-col>
                    <mdb-col col="12 mt-3">
                      <mdb-btn
                        rounded
                        :disabled="validation.roomName.invalid || validation.roomName.IncludedBlacklist || roomName == ''"
                        @click.native="onclickEnterRoom">
                        <mdb-icon icon="sign-in-alt" class="mr-1"/>
                        入室
                      </mdb-btn>
                    </mdb-col>
                  </mdb-row>
                </section>
              </div>
            </mdb-container>
          </mdb-mask>
        </div>
      </div>
    </div>
    <section class="content">
      <mdb-container class="text-muted">
        <mdb-row class="py-4">
          <mdb-col col="12" class="text-center">
            <h4 class="font-weight-bold black-text">
              <img src="@/assets/images/waaarp_logo_text_bk.png" class="caption-logo"/>
              は、WebRTCで構築されたWeb会議サービスです。
            </h4>
          </mdb-col>
          <mdb-col v-if="!signedIn" col="12" class="text-center mt-4">
            <router-link :to="{ name: 'signUp' }" class="btn btn-primary btn-rounded">
              <mdb-icon icon="user-plus" class="mr-2"/>
              無料でアカウント登録
            </router-link>
          </mdb-col>
        </mdb-row>
        <mdb-row class="py-4 d-flex flex-wrap">
          <mdb-col col="12" md="6" class="text-center py-2">
            <mdb-card v-animateOnScroll="{ animation: 'fadeIn' }" class="h-100">
              <mdb-card-body>
                <mdb-icon icon="check" size="5x" class="text-secondary" />
                <h5 class="h5 py-4">インストール不要</h5>
                <p class="text-left">面倒なアプリケーションのインストールなどは一切不要。会議室を作って、そこに相手を招待するだけで直ぐにミーティングが始められます。</p>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
          <mdb-col col="12" md="6" class="text-center py-2">
            <mdb-card v-animateOnScroll="{ animation: 'fadeIn' }" class="h-100">
              <mdb-card-body>
                <mdb-icon icon="users" size="5x" class="text-secondary" />
                <h5 class="h5 py-4">多人数対応</h5>
                <p class="text-left">多人数でも安定して会議が可能です。遠方のお客様や複数支社間でのミーティングも距離を感じることなくご利用いただけます。</p>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
          <mdb-col col="12" md="6" class="text-center py-2">
            <mdb-card v-animateOnScroll="{ animation: 'fadeIn' }" class="h-100">
              <mdb-card-body>
                <mdb-icon icon="desktop" size="5x" class="text-secondary" />
                <h5 class="h5 py-4">リアル会議室</h5>
                <p class="text-left">画面共有などの機能により、リアルな会議室を再現しています。</p>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
          <mdb-col col="12" md="6" class="text-center py-2">
            <mdb-card v-animateOnScroll="{ animation: 'fadeIn' }" class="h-100">
              <mdb-card-body>
                <mdb-icon icon="heart" size="5x" class="text-secondary" />
                <h5 class="h5 py-4">各種オプションも利用可能</h5>
                <ul>
                  <li class="text-left">ホワイトボードオプション</li>
                  <li class="text-left">議事録オプション</li>
                  <li class="text-left">会議室URL固定オプション</li>
                </ul>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
        <mdb-row class="py-4">
          <mdb-col col="12" class="text-center mt-4">
            <p class="font-weight-bold">利用方法や導入事例の詳細はWaaarp特設ページへ</p>
            <a href="https://www.iwatsu.co.jp/waaarp/" target="_blank" class="btn btn-default btn-text-transform-none btn-rounded">
              Waaarp特設ページ<mdb-icon icon="sign-out-alt" class="ml-2"/></a>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
  </div>
</template>

<script>

// libraries
import { mapGetters } from 'vuex'
import { animateOnScroll } from 'mdbvue'

import { ROOM_NAME_BLACK_LIST } from '@/lib/helper'

export default {
  name: 'Top',
  directives: {
    animateOnScroll
  },
  data() {
    return {
      innerRoomName: '',
      validation: {
        roomName: {
          invalid: false,
          IncludedBlacklist: false
        }
      }
    }
  },
  computed: {
    appURL: function() { return process.env.VUE_APP_URL },
    roomName: {
      get () {
        return this.innerRoomName
      },
      set (value) {
        this.validation.roomName.invalid = value && value.match(/^[a-zA-Z0-9-_]{12,}$/) === null
        this.validation.roomName.IncludedBlacklist = ROOM_NAME_BLACK_LIST.includes(value)
        this.innerRoomName = value
      }
    },
    ...mapGetters({
      signedIn: 'auth/signedIn'
    })
  },
  methods: {
    onclickEnterRoom: function() {
      this.$router.push({ name: 'room', params: { roomName: this.roomName } })
    }
  }
}
</script>

<style scoped lang="scss">
.top-container {
  margin-top: -60px;

  .top-logo {
    height: 4rem;
    margin: 1rem 0;
    display: inline;
  }
}
.full-bg-img {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100%;
}
.caption-logo {
  height: 2rem;
}
.room-input-group {
  span.input-group-text,
  input.form-control {
    background: transparent;
    outline: none;
    border: none;
  }

  input.form-control {
    border-radius: 0;
    border-bottom: 1px solid #ced4da !important;

    &.is-invalid,
    &.is-invalid:focus {
      border-bottom: 1px solid red !important;
      box-shadow: 0 1px 0 0 red !important;
    }
  }
}
.room-name-invalid-feedback {
  margin-top: .25rem;
  font-weight: bold;
  font-size: 0.8rem;
}
</style>
